import React from 'react';
import PropTypes from 'prop-types';

import { Link } from '@ontruck/orc';
import DriverJourneys, { useDriverJourneysContext } from 'modules/driver-journeys';

const t = {
  no_driver: 'No driver',
};

const DriverCell = ({
  isClickable,
  filterByDriverName,
  totalNumber,
  driverName,
  className,
  driverId,
  timeFrom,
}) => {
  const { isInsideDriverJourneys } = useDriverJourneysContext();

  return isClickable && !isInsideDriverJourneys ? (
    <DriverJourneys driverId={driverId} timeFrom={timeFrom}>
      <Link
        className={className}
        onClick={filterByDriverName}
        fullWidth
        text={
          <>
            {!!totalNumber && totalNumber > 1 && <strong>{totalNumber}</strong>} {driverName}
          </>
        }
        weight="bold"
      />
    </DriverJourneys>
  ) : (
    <>{driverName || t.no_driver}</>
  );
};

DriverCell.propTypes = {
  isClickable: PropTypes.bool,
  handleClick: PropTypes.func,
  totalNumber: PropTypes.number,
  driverName: PropTypes.string,
  className: PropTypes.string,
};

export default DriverCell;
